import { tns, TinySliderSettings, TinySliderInstance } from 'tiny-slider/src/tiny-slider'
import lazyLoader from '../modules/lazyLoader';
import config from '../config';

class Slider {

  private defaultConfig: TinySliderSettings;
  private slider: TinySliderInstance;
  
  constructor() {
    this.slider = null;
    this.defaultConfig = {
      items: 1.5,
      slideBy: 1,
      gutter: 5,
      speed: config.duration,
      controls: false,
      mouseDrag: false,
      touch: true,
      nav: false,
      // @ts-ignore comment
      preventScrollOnTouch: 'force',
      responsive: {
        1024: {
          disable: true
        }
      }
    }
  }

  init(node:HTMLElement, config?:TinySliderSettings) {    
    if (!node || !node.children.length) return;
    this.defaultConfig.container = node;
    this.load(config);
    return this.slider;
  }

  load = (config?:TinySliderSettings) => {
    this.create(config);  
  }

  transitionStart = () => {
    lazyLoader.update();
  }

  create = (config?:TinySliderSettings) => {
    this.slider = tns({ ...this.defaultConfig, ...config });
    this.slider.events.on('transitionStart', this.transitionStart);
  }
}

export default new Slider();





